import { useEffect, useState } from 'react'
import { viewportBottomInset } from './toast-offset'

/** Keep mobile toast clearance relative to the visible area, including while
 * a keyboard animates or iOS pans the visual viewport to an input. */
export function useToastBottomInset(enabled: boolean): number {
  const [inset, setInset] = useState(0)
  useEffect(() => {
    if (!enabled) return
    const viewport = window.visualViewport
    const sync = () =>
      setInset(
        viewportBottomInset(
          window.innerHeight,
          viewport?.height ?? window.innerHeight,
          viewport?.offsetTop ?? 0,
        ),
      )
    sync()
    viewport?.addEventListener('resize', sync)
    viewport?.addEventListener('scroll', sync)
    window.addEventListener('resize', sync)
    return () => {
      viewport?.removeEventListener('resize', sync)
      viewport?.removeEventListener('scroll', sync)
      window.removeEventListener('resize', sync)
    }
  }, [enabled])
  return enabled ? inset : 0
}
